// TODO(jordanyu): Update the copy of these descriptions to better explain
// what data is being synced for each category.
export const MERGE_CATEGORY_DESCRIPTIONS: Record<string, string> = {
  accounting: "Accounting data",
  ats: "Applicant tracking system (ATS) data including candidates and job postings",
  crm: "Customer relationship management (CRM) data including contacts and deals",
  filestorage: "File storage data including files and folders",
  hris: "Human resources information system (HRIS) data including employees",
  knowledgebase: "Knowledge base data including articles and documentation",
  ticketing: "Ticketing data including tickets and projects",
};
